var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#0D1743"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 26.0681C18.3903 26.0681 16.8465 25.4287 15.7083 24.2905C14.5701 23.1523 13.9307 21.6086 13.9307 19.9989C13.9307 18.3892 14.5701 16.8455 15.7083 15.7073C16.8465 14.5691 18.3903 13.9296 19.9999 13.9296V26.0681Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0693 20C26.0693 20.797 25.9123 21.5863 25.6073 22.3226C25.3023 23.059 24.8552 23.728 24.2916 24.2916C23.728 24.8552 23.059 25.3023 22.3226 25.6073C21.5862 25.9123 20.797 26.0693 20 26.0693V33.0059C23.4494 33.0059 26.7575 31.6356 29.1965 29.1965C31.6356 26.7575 33.0059 23.4494 33.0059 20C33.0059 16.5506 31.6356 13.2425 29.1965 10.8035C26.7575 8.3644 23.4494 6.99414 20 6.99414V13.9341C21.6091 13.9341 23.1523 14.5731 24.2904 15.7105C25.4286 16.848 26.0684 18.3909 26.0693 20Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0878 13.059C15.5633 13.059 16.7595 11.8628 16.7595 10.3872C16.7595 8.91164 15.5633 7.71545 14.0878 7.71545C12.6122 7.71545 11.416 8.91164 11.416 10.3872C11.416 11.8628 12.6122 13.059 14.0878 13.059Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMark);
export default __webpack_public_path__ + "static/media/logo-mark.0ec7534ebe718779b752ca028b20aa8c.svg";
export { ForwardRef as ReactComponent };